import Wallet from 'containers/Wallet';

export default {
  exact: true,
  name: 'Wallet',
  protected: true,
  path: '/wallets/:tab?/:groupId?',
  component: Wallet,
  permissions: ['all'],
};
